<template>
    <div>
      <div v-for="n in count" :key="n" class="card card-style mt-5 overflow-visible">
        <div class="content">
          <vue-skeleton-loader
            :height="20"
            animation="fade"
            class="w-25 mt-2 mb-1"
          />
          <vue-skeleton-loader
            :height="30"
            animation="fade"
            class="w-50 mt-1"
          />
          <div class="d-flex justify-content-between">
            <vue-skeleton-loader
              :width="200"
              :height="20"
              animation="fade"
              class="mt-1"
            />
            <vue-skeleton-loader
              :width="100"
              :height="20"
              animation="fade"
              class="mt-1 ms-1"
            />
          </div>
        </div>
      </div>
    </div>
  </template>
  
<script>
export default {
  props: {
    count: {
      default: 1,
      type: Number,
    }
  },
};
</script>
  